// removed by extract-text-webpack-plugin
module.exports = {"container":"WaitList__container___3WwXI","buttons-container":"WaitList__buttons-container___2Y6_G"};